/** Плинтусы поверх стен: чистые грани комнат дают разрывы у дверных проёмов. */
import type { PointerEvent } from "react";
import { baseboardLook } from "@/shared/catalog";
import type { BaseboardLayer, WallGraph } from "@/shared/plan";
import { roomBaseboardSpans, type Room } from "@/widgets/plan";

interface Props {
	graph: WallGraph;
	rooms: Room[];
	baseboards: BaseboardLayer;
	mmPerPx: number;
	onBaseboardPointerDown: (event: PointerEvent<SVGLineElement>, room: Room) => void;
}

export const BaseboardsLayer2D = ({
	graph,
	rooms,
	baseboards,
	mmPerPx,
	onBaseboardPointerDown,
}: Props) => {
	if (!baseboards.visible) return null;
	return (
		<g>
			{rooms.flatMap((room) => {
				const baseboard = baseboards.items[room.id];
				if (!baseboard) return [];
				const look = baseboardLook(baseboard);
				return roomBaseboardSpans(graph, room).flatMap((span) => {
					const wall = graph.walls[span.wallId];
					const start = wall && graph.nodes[wall.a];
					const end = wall && graph.nodes[wall.b];
					if (!start || !end) return [];
					const dx = end.x - start.x;
					const dy = end.y - start.y;
					const length = Math.hypot(dx, dy);
					if (length === 0) return [];
					const offset = wall.thickness / 2 + mmPerPx;
					const normal = {
						x: (-dy / length) * span.side * offset,
						y: (dx / length) * span.side * offset,
					};
					return (
						<line
							key={`${room.id}:${span.wallId}:${span.from}`}
							x1={start.x + (dx * span.from) / length + normal.x}
							y1={start.y + (dy * span.from) / length + normal.y}
							x2={start.x + (dx * span.to) / length + normal.x}
							y2={start.y + (dy * span.to) / length + normal.y}
							stroke={look.color}
							strokeWidth={Math.max(4 * mmPerPx, 12)}
							strokeLinecap="butt"
							onPointerDown={(event) => onBaseboardPointerDown(event, room)}
						/>
					);
				});
			})}
		</g>
	);
};
